(function() {
  if (customElements.get('ap-product-info-drawer')) return;

  class ProductInfoDrawer extends HTMLElement {
    connectedCallback() {
      window.theme = window.theme || {};

      if (theme.apProductInfoDrawer && theme.apProductInfoDrawer !== this) {
        this.remove();
        return;
      }
      theme.apProductInfoDrawer = this;

      // Moving the element into #ProductModals re-triggers connectedCallback.
      if (this.initialized) return;
      this.initialized = true;

      this.panel = this.querySelector('.ap-product-info-drawer__panel');
      this.holder = this.querySelector('[data-drawer-holder]');
      this.spinner = this.querySelector('[data-drawer-spinner]');
      this.cache = {};
      this.isOpen = false;
      this.gallery = null;
      this.trigger = null;

      var modals = document.getElementById('ProductModals');
      if (modals && this.parentNode !== modals) {
        modals.appendChild(this);
      }

      this.addEventListener('click', function(evt) {
        if (evt.target.closest('[data-drawer-close]')) this.close();
      }.bind(this));

      document.addEventListener('click', function(evt) {
        var trigger = evt.target.closest('[data-ap-product-drawer-trigger]');
        if (!trigger || !trigger.dataset.productHandle) return;
        evt.preventDefault();
        this.open(trigger.dataset.productHandle, trigger);
      }.bind(this));

      document.addEventListener('ap-product-drawer:open', function(evt) {
        if (evt.detail && evt.detail.handle) {
          this.open(evt.detail.handle, evt.detail.trigger);
        }
      }.bind(this));

      // Close when another drawer/modal opens (e.g. the cart drawer)
      document.addEventListener('drawerOpen', function(evt) {
        var fromSelf = evt.detail && evt.detail.source === 'ap-product-info-drawer';
        if (this.isOpen && !fromSelf) this.close();
      }.bind(this));
    }

    open(handle, trigger) {
      if (this.isOpen) {
        this.load(handle);
        return;
      }

      this.trigger = trigger || null;

      document.dispatchEvent(new CustomEvent('drawerOpen', {
        detail: { source: 'ap-product-info-drawer' }
      }));
      document.dispatchEvent(new CustomEvent('cart:close'));

      this.classList.add('is-active');
      this.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('ap-product-drawer-open');

      this._onKeyup = function(evt) {
        if (evt.keyCode === 27) this.close();
      }.bind(this);
      window.addEventListener('keyup', this._onKeyup);

      setTimeout(function() {
        if (theme.a11y && theme.a11y.trapFocus) {
          theme.a11y.trapFocus({
            container: this.panel,
            namespace: 'apProductDrawer'
          });
        } else {
          this.panel.focus();
        }
      }.bind(this), 100);

      this.isOpen = true;
      this.load(handle);
    }

    close() {
      if (!this.isOpen) return;

      this.classList.remove('is-active');
      this.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('ap-product-drawer-open');

      if (this._onKeyup) window.removeEventListener('keyup', this._onKeyup);

      if (theme.a11y && theme.a11y.removeTrapFocus) {
        theme.a11y.removeTrapFocus({
          container: this.panel,
          namespace: 'apProductDrawer'
        });
      }

      if (this.trigger && typeof this.trigger.focus === 'function') {
        this.trigger.focus();
      }

      this.isOpen = false;
      document.dispatchEvent(new CustomEvent('apProductDrawer:close'));
    }

    load(handle) {
      this.destroyGallery();
      this.holder.innerHTML = '';

      if (this.cache[handle]) {
        this.holder.innerHTML = this.cache[handle];
        this.initGallery();
        return;
      }

      this.spinner.classList.remove('hide');

      var root = (window.theme && theme.routes && theme.routes.home) ? theme.routes.home : '';
      if (root === '/') root = '';
      var url = (root + '/products/' + handle + '.js').replace('//', '/');

      fetch(url)
        .then(function(response) {
          if (!response.ok) throw new Error(response.status);
          return response.json();
        })
        .then(function(product) {
          var html = this.buildContent(product, root);
          this.cache[handle] = html;
          this.spinner.classList.add('hide');
          this.holder.innerHTML = html;
          this.initGallery();
        }.bind(this))
        .catch(function() {
          this.spinner.classList.add('hide');
          window.location.href = root + '/products/' + handle;
        }.bind(this));
    }

    buildContent(product, root) {
      var esc = function(s) {
        return String(s == null ? '' : s).replace(/[&<>"]/g, function(c) {
          return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
        });
      };
      var imageUrl = function(src, width) {
        return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
      };

      // Prefer product.media for intrinsic dimensions (reserves space, avoids CLS)
      var items = [];
      if (product.media && product.media.length) {
        product.media.forEach(function(m) {
          if (m.preview_image && m.preview_image.src) {
            items.push({ src: m.preview_image.src, w: m.preview_image.width, h: m.preview_image.height });
          }
        });
      }
      if (!items.length && product.images) {
        items = product.images.map(function(src) { return { src: src }; });
      }
      items = items.slice(0, 8);

      var gallery = '';
      if (items.length) {
        // All eager: lazy images inside Flickity's transformed slides don't
        // load until slid into view, leaving blank slides
        var slides = items.map(function(item) {
          var dims = item.w && item.h ? ' width="' + item.w + '" height="' + item.h + '"' : '';
          return '<div class="ap-product-drawer__slide"><img src="' + esc(imageUrl(item.src, 720)) +
            '"' + dims + ' alt="' + esc(product.title) + '" loading="eager"></div>';
        }).join('');
        gallery = '<div class="ap-product-drawer__gallery' +
          (items.length === 1 ? ' ap-product-drawer__gallery--single' : '') +
          '" data-drawer-gallery>' + slides + '</div>';
      }

      var price = '';
      if (typeof product.price === 'number' && window.theme && theme.Currency) {
        price = theme.Currency.formatMoney(product.price, theme.settings && theme.settings.moneyFormat);
        if (product.price_varies) price = 'ab ' + price;
      }

      // product.description is trusted store-authored HTML
      return '<div class="ap-product-drawer">' +
        gallery +
        '<div class="ap-product-drawer__info">' +
          '<h2 class="ap-product-drawer__title h3">' + esc(product.title) + '</h2>' +
          (price ? '<div class="ap-product-drawer__price">' + price + '</div>' : '') +
          (product.description ? '<div class="ap-product-drawer__description rte">' + product.description + '</div>' : '') +
          '<a href="' + esc(root + product.url) + '" class="btn ap-product-drawer__cta">Alle Details ansehen</a>' +
        '</div>' +
      '</div>';
    }

    destroyGallery() {
      if (this.gallery) {
        this.gallery.destroy();
        this.gallery = null;
      }
    }

    initGallery() {
      var el = this.holder.querySelector('[data-drawer-gallery]');
      if (!el || el.children.length < 2) return;
      if (!window.theme || !theme.Slideshow) return;

      // adaptiveHeight animates the viewport height per slide, shifting
      // everything below the gallery — slides have a fixed aspect box instead
      this.gallery = new theme.Slideshow(el, {
        pageDots: true,
        prevNextButtons: true,
        adaptiveHeight: false,
        wrapAround: true
      });

      setTimeout(function() {
        if (this.gallery) this.gallery.resize();
      }.bind(this), 450);
    }
  }

  customElements.define('ap-product-info-drawer', ProductInfoDrawer);
})();
